import React from 'react';
import { NumericFormat } from 'react-number-format';
import InputField from './InputField';

const AmountInputField = (props) => {
  const {
    error,
    id,
    name,
    placeholder,
    value,
    decimalValue,
    helperText,
    onlyPositive,
    onChange,
    errorsHandler,
    dontShowErrLabel,
    tooltipText,
    placement,
    prefix,
    suffix,
    disabled,
    required,
    readOnly,
    className = '',
  } = props || {};

  const decimalScale = decimalValue ?? 2;
  const thousandSeparator = process.env.REACT_APP_THOUSAND_SEPARATOR;
  const decimalSeparator = process.env.REACT_APP_DECIMAL_SEPARATOR;

  return (
    <NumericFormat
      id={id}
      name={name}
      value={value}
      customInput={InputField}
      placeholder={placeholder}
      thousandSeparator={thousandSeparator}
      decimalSeparator={decimalSeparator}
      decimalScale={decimalScale}
      className={`currency-input-field ${className}`}
      fixedDecimalScale
      allowNegative={!onlyPositive}
      prefix={prefix || ''}
      suffix={suffix || ''}
      onChange={onChange}
      required={required}
      error={error}
      errorsHandler={errorsHandler}
      dontShowErrLabel={dontShowErrLabel}
      tooltipText={tooltipText}
      placement={placement}
      helperText={helperText}
      disabled={disabled}
      readOnly={readOnly}
    />
  );
};

export default AmountInputField;
